<div class="footer"><span>{{'FOOTER_COPYRIGHT' | translator}}</span></div>